import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ViewType } from '../../models/view-type';

@Component({
  selector: 'app-booking-type',
  templateUrl: './booking-type.component.html',
  styleUrls: ['./booking-type.component.css']
})
export class BookingTypeComponent implements OnInit {

  @Input()
  maxLenNamePack?: number;

  @Input()
  imageSource: string;

  @Input()
  description: string;

  @Input()
  additionalDescription: string;

  @Input()
  title: string;

  @Input()
  url: string;

  @Input()
  viewType: ViewType = ViewType.Buttons;

  constructor(protected router: Router) { }

  ngOnInit() {
  }

  onClick() {
    if (this.url) {
      this.router.navigateByUrl(this.url);
    }
  }

  get changeFontSizeClass(): string {
    return this.maxLenNamePack > 12 ? 'fontSizeTitle' : '';
  }

  get isListMode(): boolean {
    return this.viewType === ViewType.List;
  }

}
